import CLIENT from '../utils/restClient';
import Logger, {LOG_LEVELS, ALL_MESSAGES} from '../utils/logger';
import FileSaver from 'file-saver';
import JSZip from 'jszip';
import { FileValidationHelper } from '../utils/helpers';
export const MODULE_NAME = 'TRANSACTIONS_CONTROLLER';

const log = new Logger(MODULE_NAME, LOG_LEVELS.DEBUG);

function namespaced(name) {
  return MODULE_NAME + '.' + name;
};

function selectTransactionIDsForFirstPage(transactionIDs, startIndex, docsPerPage) {
  var aPage = {
    reference: "",
    invoices: [],
    warnings: [],
    errors: [],
    deleteLogs: [],
    documentsOnHold: [],
    documentsInInbox: []
  }
  if ((transactionIDs !== undefined) && (transactionIDs.message === undefined)) {
    //startIndex parameter: start index of page in (imaginary) concatented array of invoices, warnings,...
    //Initializing six transaction details arrays
    let invoices = [];
    let warnings = [];
    let errors = [];
    let deleteLogs = [];
    let documentsOnHold = [];
    let documentsInInbox = []; 
    //Length of the current transaction details arrays in the state
    let invoicesCount = transactionIDs.invoices.length;
    let warningsCount = transactionIDs.warnings.length;
    let errorsCount = transactionIDs.errors.length;
    let deleteLogsCount = transactionIDs.deleteLogs.length;
    let documentsOnHoldCount = transactionIDs.documentsOnHold.length;
    let documentsInInboxCount = transactionIDs.documentsInInbox.length;
    //Start index of each transaction detail type (invoices, warnings,...) in the (imaginary) concatenated array of invoices, warnings,...
    let invoicesStartIndex = 0;
    let warningsStartIndex = invoicesCount;
    let errorsStartIndex = warningsStartIndex + warningsCount;
    let deleteLogsStartIndex = errorsStartIndex + errorsCount;
    let documentsOnHoldStartIndex = deleteLogsStartIndex + deleteLogsCount;
    let documentsInInboxStartIndex = documentsOnHoldStartIndex + documentsOnHoldCount;
    //Variables needed to construct a transactionIDs object for one page
    let localStartIndex = startIndex; 
    let docsInPage = 0;
    //Constructing six arrays (invoices, warnings,...)
    if (startIndex < warningsStartIndex) {
      invoices = transactionIDs.invoices.slice(localStartIndex, localStartIndex+docsPerPage);
      docsInPage = invoices.length;
      localStartIndex = 0;
    }
    if ((docsInPage < docsPerPage) && (startIndex < errorsStartIndex)) {
      if (localStartIndex !== 0) {
        localStartIndex = localStartIndex - invoicesCount;
      };
      warnings = transactionIDs.warnings.slice(localStartIndex, localStartIndex+docsPerPage-docsInPage);
      docsInPage = docsInPage + warnings.length;
      localStartIndex = 0;
    }
    if ((docsInPage < docsPerPage) && (startIndex < deleteLogsStartIndex)) {
      if (localStartIndex !== 0) {
        localStartIndex = localStartIndex - invoicesCount - warningsCount;
      };
      errors = transactionIDs.errors.slice(localStartIndex, localStartIndex+docsPerPage-docsInPage);
      docsInPage = docsInPage + errors.length;
      localStartIndex = 0;
    }
    if ((docsInPage < docsPerPage) && (startIndex < documentsOnHoldStartIndex)) {
      if (localStartIndex !== 0) {
        localStartIndex = localStartIndex - invoicesCount - warningsCount - errorsCount;
      };
      deleteLogs = transactionIDs.deleteLogs.slice(localStartIndex, localStartIndex+docsPerPage-docsInPage);
      docsInPage = docsInPage + deleteLogs.length;
      localStartIndex = 0;
    }
    if ((docsInPage < docsPerPage) && (startIndex < documentsInInboxStartIndex)) {
      if (localStartIndex !== 0) {
        localStartIndex = localStartIndex - invoicesCount - warningsCount - errorsCount - deleteLogsCount;
      };
      documentsOnHold = transactionIDs.documentsOnHold.slice(localStartIndex, localStartIndex+docsPerPage-docsInPage);
      docsInPage = docsInPage + documentsOnHold.length;
      localStartIndex = 0;
    }
    if (docsInPage < docsPerPage) {
      if (localStartIndex !== 0) {
        localStartIndex = localStartIndex - invoicesCount - warningsCount - errorsCount - deleteLogsCount - documentsOnHoldCount;
      };
      documentsInInbox = transactionIDs.documentsInInbox.slice(localStartIndex, localStartIndex+docsPerPage-docsInPage);
      docsInPage = docsInPage + documentsInInbox.length;
      localStartIndex = 0;
    }
    //the page object
    aPage = {
      reference: transactionIDs.reference,
      invoices,
      warnings,
      errors,
      deleteLogs,
      documentsOnHold,
      documentsInInbox
    }
  }
  return aPage;
};

const SEARCHIDS = namespaced('SEARCHIDS');
const SEARCHIDS_OK = namespaced('SEARCHIDS_OK');
const SEARCHIDS_FAIL = namespaced('SEARCHIDS_FAIL');
const SEARCHPAGE = namespaced('SEARCHPAGE');
const SEARCHPAGE_OK = namespaced('SEARCHPAGE_OK');
const SEARCHPAGE_FAIL = namespaced('SEARCHPAGE_FAIL');
const ACTION = namespaced('ACTION');
const ACTION_OK = namespaced('ACTION_OK');
const ACTION_FAIL = namespaced('ACTION_FAIL');
const GETXML = namespaced('GETXML');
const GETXML_OK = namespaced('GETXML_OK');
const GETXML_FAIL = namespaced('GETXML_FAIL');
const GETCOMMENT = namespaced('GETCOMMENT');
const GETCOMMENT_OK = namespaced('GETCOMMENT_OK');
const GETCOMMENT_FAIL = namespaced('GETCOMMENT_FAIL');
const SETCOMMENT = namespaced('SETCOMMENT');
const SETCOMMENT_OK = namespaced('SETCOMMENT_OK');
const SETCOMMENT_FAIL = namespaced('SETCOMMENT_FAIL');
const DELETECOMMENT = namespaced('DELETECOMMENT');
const DELETECOMMENT_OK = namespaced('DELETECOMMENT_OK');
const DELETECOMMENT_FAIL = namespaced('DELETECOMMENT_FAIL');
const GETATTACHMENT = namespaced('GETATTACHMENT');
const GETATTACHMENT_OK = namespaced('GETATTACHMENT_OK');
const GETATTACHMENT_FAIL = namespaced('GETATTACHMENT_FAIL');
const DOWNLOAD_ATTACHMENT = namespaced('DOWNLOAD_ATTACHMENT');
const DOWNLOAD_ATTACHMENT_OK = namespaced('DOWNLOAD_ATTACHMENT_OK');
const DOWNLOAD_ATTACHMENT_FAIL = namespaced('DOWNLOAD_ATTACHMENT_FAIL');
const UPLOAD_ATTACHMENT = namespaced('UPLOAD_ATTACHMENT');
const UPLOAD_ATTACHMENT_OK = namespaced('UPLOAD_ATTACHMENT_OK');
const UPLOAD_ATTACHMENT_FAIL = namespaced('UPLOAD_ATTACHMENT_FAIL');
const DELETE_ATTACHMENT = namespaced('DELETE_ATTACHMENT');
const DELETE_ATTACHMENT_OK = namespaced('DELETE_ATTACHMENT_OK');
const DELETE_ATTACHMENT_FAIL = namespaced('DELETE_ATTACHMENT_FAIL');

export const ACTION_TYPES = {
  SEARCHIDS,
  SEARCHIDS_OK,
  SEARCHIDS_FAIL,
  SEARCHPAGE,
  SEARCHPAGE_OK,
  SEARCHPAGE_FAIL,
  ACTION,
  ACTION_OK,
  ACTION_FAIL,
  GETXML,
  GETXML_OK,
  GETXML_FAIL,
  GETCOMMENT,
  GETCOMMENT_OK,
  GETCOMMENT_FAIL,
  SETCOMMENT,
  SETCOMMENT_OK,
  SETCOMMENT_FAIL,
  DELETECOMMENT,
  DELETECOMMENT_OK,
  DELETECOMMENT_FAIL,
  GETATTACHMENT,
  GETATTACHMENT_OK,
  GETATTACHMENT_FAIL,
  DOWNLOAD_ATTACHMENT,
  DOWNLOAD_ATTACHMENT_OK,
  DOWNLOAD_ATTACHMENT_FAIL,
  UPLOAD_ATTACHMENT,
  UPLOAD_ATTACHMENT_OK,
  UPLOAD_ATTACHMENT_FAIL,
  DELETE_ATTACHMENT,
  DELETE_ATTACHMENT_OK,
  DELETE_ATTACHMENT_FAIL
};

export const updateSubStateFromAction = (state = { data: undefined,loading: false, error: null}, action) => {
  log.debug('updateSubStateFromAction: ', action, state);
  const getNewState = (action, state) => {
    switch (action.type) {
      case SEARCHIDS:
        return Object.assign({}, state, {loading: true, error: null, transactionIDs: undefined});
      case SEARCHIDS_OK:
        return Object.assign({}, state, {transactionIDs: action.response, loading: false, error: null});
      case SEARCHIDS_FAIL:
        return Object.assign({}, state, {transactionIDs: undefined, loading: false, error: action.error});
      case SEARCHPAGE:
        return Object.assign({}, state, {loading: true, error: null, transactionPage: undefined});
      case SEARCHPAGE_OK:
        return Object.assign({}, state, {transactionPage: action.response, loading: false, error: null});
      case SEARCHPAGE_FAIL:
        return Object.assign({}, state, {transactionPage: undefined, loading: false, error: action.error});
      case ACTION:
        return Object.assign({}, state, {loading: true, error: null, actionResults: undefined});
      case ACTION_OK:
        return Object.assign({}, state, {actionResults: action.response, loading: false, error: null});
      case ACTION_FAIL:
        return Object.assign({}, state, {actionResults: undefined, loading: false, error: action.error});
      case GETXML:
        return Object.assign({}, state, {loading: true, error: null});
      case GETXML_OK:
        return Object.assign({}, state, {situationData: action.response, loading: false, error: null});
      case GETXML_FAIL:
        return Object.assign({}, state, {situationData: undefined, loading: false, error: action.error});
      case GETCOMMENT:
        return Object.assign({}, state, {loading: true, error: null});
      case GETCOMMENT_OK:
        return Object.assign({}, state, {loading: false, error: null});
      case GETCOMMENT_FAIL:
        return Object.assign({}, state, {loading: false, error: action.error});
      case SETCOMMENT:
        return Object.assign({}, state, {loading: true, error: null});
      case SETCOMMENT_OK:
        return Object.assign({}, state, {loading: false, error: null});
      case SETCOMMENT_FAIL:
        return Object.assign({}, state, {loading: false, error: action.error});
      case DELETECOMMENT:
        return Object.assign({}, state, {loading: true, error: null});
      case DELETECOMMENT_OK:
        return Object.assign({}, state, {loading: false, error: null});
      case DELETECOMMENT_FAIL:
        return Object.assign({}, state, {loading: false, error: action.error});
      case GETATTACHMENT:
        return  Object.assign({}, state, {loading: true, error: null});
      case GETATTACHMENT_OK:
        return Object.assign({}, state, {loading: false, error: null});
      case GETATTACHMENT_FAIL:
        return Object.assign({}, state, {loading: false, error: action.error});
      case DOWNLOAD_ATTACHMENT:
        return Object.assign({}, state, {loading: true, error: null});
      case DOWNLOAD_ATTACHMENT_OK:
        return Object.assign({}, state, {loading: false, error: null});
      case DOWNLOAD_ATTACHMENT_FAIL:
        return Object.assign({}, state, {loading: false, error: action.error});
      case UPLOAD_ATTACHMENT:
        return Object.assign({}, state, {loading: true, error: null});
      case UPLOAD_ATTACHMENT_OK:
        return Object.assign({}, state, {loading: false, error: null});
      case UPLOAD_ATTACHMENT_FAIL:
        return Object.assign({}, state, {loading: false, error: action.error});
      case DELETE_ATTACHMENT:
        return Object.assign({}, state, {loading: true, error: null});
      case DELETE_ATTACHMENT_OK:
        return Object.assign({}, state, {loading: false, error: null});
      case DELETE_ATTACHMENT_FAIL:
        return Object.assign({}, state, {loading: false, error: action.error});
      default:
        return state;
    }
  };
  const newState = getNewState(action, state);
  log.debug('updateSubStateFromAction: newState', newState);
  return newState;
};

export const API = {
  resetSearchIDsAndPage: () => {
    return (dispatch, getState) => {
      dispatch({type: SEARCHIDS_OK, response: []});
      dispatch({type: SEARCHPAGE_OK, response: []});
    }
  },
  doSearchIDsAndFirstPage(filterParams, docsPerPage) {
    return (dispatch, getState) => {
      dispatch({type: SEARCHIDS});
      log.debug('doSearchTransactionIDsAndFirstPage():', filterParams);
      CLIENT.searchTransactionIDs(filterParams)
        .then((response) => {
          log.debug('doSearchIDsAndFirstPage(): search IDs succeeded: ', response);
          dispatch({type: SEARCHIDS_OK, response});
          const firstPage = selectTransactionIDsForFirstPage(response, 0, docsPerPage)
          dispatch({type: SEARCHPAGE});
          log.debug('doSearchIDsAndFirstPage():', firstPage);
          CLIENT.searchTransactionsPage(firstPage)
            .then((response) => {   
              log.debug('doSearchIDsAndFirstPage(): get first page succeeded: ', response);         
              dispatch({type: SEARCHPAGE_OK, response});
            })
            .catch((error) => {
              log.debug('doSearchIDsAndFirstPage(): get first page failed: ', error);
              dispatch({type: SEARCHPAGE_FAIL, error});
            });
        })
        .catch((error) => {
          log.debug('doSearchTransactionIDsAndFirstPage(): search IDs failed: ', error);
          dispatch({type: SEARCHIDS_FAIL, error});
        });
    }
  },
  doSearchPage: (transactionIDs, startIndex, docsPerPage) => {
    return (dispatch, getState) => {
      dispatch({type: SEARCHPAGE});
      const aPage = selectTransactionIDsForFirstPage(transactionIDs, startIndex, docsPerPage)
      log.debug('doSearchPage():', aPage);
      CLIENT.searchTransactionsPage(aPage)
        .then((response) => {
          log.debug('doSearchPage(): succeeded: ', response);
          dispatch({type: SEARCHPAGE_OK, response});
        })
        .catch((error) => {
          log.debug('doSearchPage(): failed: ', error);
          dispatch({type: SEARCHPAGE_FAIL, error});
        });
    }
  },
  doAction: (action, ids, reason, cb) => {
    log.clearAllDictionaryErrors();
    cb = typeof cb === 'function' ? cb : () => {};
    ids = Array.isArray(ids) ? ids : [ids];
    log.clearSuccessMessage(ALL_MESSAGES.TRANSACTION_ACTION_SUCCESS);
    log.clearDictionaryError(ALL_MESSAGES.TRANSACTION_ACTION_ERROR);
    return (dispatch, getState) => {
      dispatch({type: ACTION});
      log.debug('doAction(): ', action, ids, reason);
      CLIENT.doActionOnTransactions(action, ids, reason)
        .then((response) => {
          log.debug('doAction(): succeeded: ', response);
          log.setDictionaryMessage(ALL_MESSAGES.TRANSACTION_ACTION_SUCCESS, (action === 'forceToError'? 'force to error' : action));
          dispatch({type: ACTION_OK, response});
          cb (null, response);
        })
        .catch((error) => {
          log.debug('doAction(): failed: ', error);
          if(error.status === 409) {
            log.setDictionaryMessage(ALL_MESSAGES.TRANSACTION_ACTION_ERROR, action); 
          }
          dispatch({type: ACTION_FAIL, error});
          cb(error, null);
        });
    };
  },
  saveTransactionXMLMultiple: (ids) => {
    // We don't need to do a single id endpoint GET; as the multi id endpoint can accept a single id array
    // If there is only one document selected, it downloads as .xml; if >1 it downloads as .zip
    return (dispatch, getState) => {
      dispatch({type: GETXML});
      log.debug('saveTransactionXMLMultiple: ', ids);
      CLIENT.saveTransactionXMLMultiple(ids)
        .then((response) => {
          log.debug('saveTransactionXMLMultiple(): succeeded: ', response);
          let zip = new JSZip;
          if (response.documentDataList.length > 1) {
            // >1 iterate over all ids
            response.documentDataList.map((item, index) => {
              let xml = item.documentData;
              zip.file(item.documentId + '.xml', xml);
            });
            zip.generateAsync({type: "blob"})
              .then(function (content) {
                FileSaver.saveAs(content, 'Transactions.zip');
              })
          } else {
            // Single id
            let xml = response.documentDataList[0].documentData;
            let id = response.documentDataList[0].documentId;
            let thisFile = new File([xml], id + '.xml', {type: 'text/plain;charset=utf-8'});
            FileSaver.saveAs(thisFile);
          }
          dispatch({type: GETXML_OK, response});
        })
        .catch((error) => {
          log.debug('saveTransactionXMLMultiple(): failed: ', error);
          dispatch({type: GETXML_FAIL, error});
        });
    }
  },
  doGetTransactionComment: (transactionId,  callback=()=>{}) =>  {
    return (dispatch, getState) => {
      dispatch({type: GETCOMMENT});
      log.debug('doGetTransactionComment():', transactionId);
      CLIENT.getTransactionComment(transactionId)
        .then((response) => {
          log.debug('doGetTransactionComment(): succeeded: ', response);
          dispatch({type: GETCOMMENT_OK, response});
          callback(null, response);
        })
        .catch((error) => {
          log.debug('doGetTransactionComment(): failed: ', error);
          dispatch({type: GETCOMMENT_FAIL, error});
          callback(error, null);
        });
    }
  },
  doPutTransactionComment: (transactionId, comment, callback) => {
    return (dispatch, getState) => {
      dispatch({type: SETCOMMENT});
      CLIENT.updateTransactionComment(transactionId, comment)
        .then((response) => {
          log.debug('doPutTransactionComment(): succeeded');
          dispatch({type: SETCOMMENT_OK, response});
          callback(null, response);
        })
        .catch((error) => {
          log.debug('doPutTransactionComment(): error' );
          dispatch({type: SETCOMMENT_FAIL, error});
          callback(error, null);
        });
    }
  },
  doDeleteTransactionComment: (transactionId, callback) => {
    return (dispatch, getState) => {
      dispatch({type: DELETECOMMENT});
      CLIENT.deleteTransactionComment(transactionId)
        .then((response) => {
          log.debug('doDeleteTransactionComment(): succeeded');
          dispatch({type: DELETECOMMENT_OK, response});
          callback(null, response);
        })
        .catch((error) => {
          log.debug('doDeleteTransactionComment(): error' );
          dispatch({type: DELETECOMMENT_FAIL, error});
          callback(error, null);
        });
    }
  },
  doGetTransactionAttachment: (transactionId, callback) => {
    return (dispatch, getState) => {
      dispatch({type: GETATTACHMENT});
      log.debug('doGetTransactionAttachment(): transactionId: ', transactionId);
      CLIENT.getTransactionAttachment(transactionId)
      .then((response) => {
        log.debug('doGetTransactionAttachment(): succeeded : ', response);
        dispatch({type: GETATTACHMENT_OK, response: response});
        callback(null, response); 
      })
      .catch((error) => {
        log.debug('doGetTransactionAttachment(): error' );
        dispatch({type: GETATTACHMENT_FAIL, error});
        callback(error, null);
      });
    }
  },
  doDownloadTransactionAttachment: (params) => {
    return (dispatch, getState) => {
      dispatch({type: DOWNLOAD_ATTACHMENT});
      log.debug('doDownloadTransactionAttachment(): params: ', params);
      CLIENT.downloadTransactionAttachment(params.mimeType, params.uri)
      .then((blob) => {
        dispatch({type: DOWNLOAD_ATTACHMENT_OK, reponse: blob});
        FileSaver.saveAs(blob, params.fileName);
      })
      .catch((error) => {
        log.debug('doDownloadTransactionAttachment(): error' );
        dispatch({type: DOWNLOAD_ATTACHMENT_FAIL, error}); 
      });
    }
  },
  doUploadTransactionAttachment: (attachmentData, callback)  => {
      log.clearAllDictionaryErrors();
      return (dispatch, getState) => {
      dispatch({type: UPLOAD_ATTACHMENT});
      CLIENT.uploadTransactionAttachment(attachmentData)
        .then((response) => {
          log.debug('doUploadTransactionAttachment(): succeeded');
          dispatch({type: UPLOAD_ATTACHMENT_OK, response});
          callback(null, response);
        })
        .catch((error) => {
            if(error.status === 406)
                log.setDictionaryMessage(ALL_MESSAGES.VIRUS_SCAN_FAILED);
            else if(error.status === 400) {
              let validationMessage = FileValidationHelper.getFileValidationMessage(error.message);
              if (validationMessage) {
                  log.setDictionaryMessage(validationMessage);
              } else {
                log.setDictionaryMessage(ALL_MESSAGES.UNABLE_TO_PROCESS_FILE, error.message);
              }
            }
            log.debug('doUploadTransactionAttachment(): error' );
            dispatch({type: UPLOAD_ATTACHMENT_FAIL, error});
            callback(error, null);
        });
    }
  },
  doDeleteTransactionAttachment: (transactionId, callback) => {
    return (dispatch, getState) => {
      dispatch({type: DELETE_ATTACHMENT});
      CLIENT.deleteTransactionAttachment(transactionId)
        .then((response) => {
          log.debug('doDeleteTransactionAttachment(): succeeded');
          dispatch({type: DELETE_ATTACHMENT_OK, response});
          callback(null, response);
        })
        .catch((error) => {
          log.debug('doDeleteTransactionAttachment(): error' );
          dispatch({type: DELETE_ATTACHMENT_FAIL, error});
          callback(error, null);
        });
    }
  },
};

export default API;